import {
  NorthEast as ArrowUpRight,
  SouthEast as ArrowDownRight,
  East as ArrowRight
} from '@mui/icons-material'
import {Chip, ChipOwnProps} from '@mui/material'

type KpiPillProps = {
  value: React.ReactNode
  icon?: ChipOwnProps['icon']
}

const KpiPillPositive = ({value, icon}: KpiPillProps) => {
  return (
    <Chip
      variant="filled"
      sx={{
        color: ({palette}) => palette.success.dark,
        background: 'rgba(0, 171, 80, 0.1)',
        fontSize: 16,
        fontWeight: 500
      }}
      icon={icon}
      label={value}
    />
  )
}

const KpiPillNegative = ({value, icon}: KpiPillProps) => {
  return (
    <Chip
      variant="filled"
      sx={{
        color: ({palette}) => palette.error.main,
        background: 'rgba(218, 9, 1, 0.1)',
        fontSize: 16,
        fontWeight: 500
      }}
      icon={icon}
      label={value}
    />
  )
}

const KpiPillNeutral = ({value}: {value: React.ReactNode}) => {
  return (
    <Chip
      variant="filled"
      sx={{
        color: ({palette}) => palette.secondary.main,
        background: 'rgba(84, 112, 140, 0.1)',
        fontSize: 16,
        fontWeight: 500
      }}
      icon={<ArrowRight color="inherit" data-test-id="arrow-right-icon" />}
      label={value}
    />
  )
}

export type ActualDeltaChipProps = {
  actual?: number | string
  diff: number
}

export const PositiveActualDelta: React.FC<ActualDeltaChipProps> = ({actual, diff}) => {
  if (diff > 0) {
    return (
      <KpiPillPositive
        value={actual}
        icon={<ArrowUpRight color="inherit" data-test-id="arrow-up-icon" />}
      />
    )
  } else if (diff < 0) {
    return (
      <KpiPillNegative
        value={actual}
        icon={<ArrowDownRight color="inherit" data-test-id="arrow-down-icon" />}
      />
    )
  }

  return <KpiPillNeutral value={actual} />
}

export const NegativeActualDelta: React.FC<ActualDeltaChipProps> = ({actual, diff}) => {
  if (diff > 0) {
    return (
      <KpiPillNegative
        value={actual}
        icon={<ArrowUpRight color="inherit" data-test-id="arrow-up-icon" />}
      />
    )
  } else if (diff < 0) {
    return (
      <KpiPillPositive
        value={actual}
        icon={<ArrowDownRight color="inherit" data-test-id="arrow-down-icon" />}
      />
    )
  }

  return <KpiPillNeutral value={actual} />
}
